// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#80a748',
            // (optional) tweak these if you want tighter control:
            // light: '#9cc46a',
            // dark: '#5d7b33',
            // contrastText: '#ffffff',
        },
    },
    typography: {
        fontFamily: 'Arial, Helvetica, sans-serif',
    },
});

export default theme;